<script lang="ts">
    export let skills : string[] = []
    export let searchTerm : string

    let sortedSkills = skills;

    if(searchTerm) {
        sortedSkills = [searchTerm, ...skills.filter(skill => skill !== searchTerm)]
    }
</script>


<div class="skills">
    <h4>Skills</h4>
    <div class="skills__list">
        { #each sortedSkills.slice(0, 6) as skill }
            <span class="skills__block" class:highlight-skill={skill === searchTerm}>
                {skill}
            </span>
        { /each }
        { #if skills.length > 6}
            <span class="skills__more">+{skills.length - 6} more</span>
        { /if }
    </div>
</div>

<style lang="postcss">
    .skills {
        & .skills__list { 
            display: flex;
            flex-wrap: wrap;
            gap:8px;
            margin-bottom:24px;
            & .skills__block {
                font-weight: 400;
                font-size: 16px;
                color: rgb(92, 92, 92);
                background-color: rgb(243, 244, 245);
                padding:0 12px;
                border-radius: 3px;
                height:35px;
                display: flex;
                align-items: center;
            }

            & .skills__more {
                display: flex;
                align-items: center;
                height:35px;
            }

            & .highlight-skill {
                color: rgb(94, 165, 238);
                background: rgb(228, 240, 252);
            }
        }
    }
</style>